// Contenido bilingüe del sitio. Todo el texto es editable desde este archivo.
export const content = {
  es: {
    brandName: "CONSULTORA SER",
    skipToContent: "Saltar al contenido principal",
    nav: {
      home: "Inicio",
      about: "Quiénes somos",
      team: "Equipo",
      services: "Servicios",
      diaspora: "Servicios para Salvadoreños",
      contact: "Contacto",
    },
    cta: "Conversemos",
    brandTagline: "Solidaridad - Equidad - Respeto",
    hero: {
      overline: "Consultoría · Desarrollo · Cooperación",
      line1: "Construimos cambios sostenibles",
      line2: "a través de redes de cooperación, alianzas, diálogo y acción conjunta.",
      sub: "La red de profesionales de CONSULTORA SER acompañan a organizaciones en procesos de educación, formación, investigación, planificación estratégica, evaluación, gestión orientada a resultados y fortalecimiento de organizaciones.",
      primary: "Conversemos",
      secondary: "Conozca nuestra experiencia",
    },
    marquee: ["Educación", "Formación", "Investigación", "Evaluación", "Planificación", "Datos", "Aprendizaje", "Fortalecimiento"],
    whoWeAre: {
      overline: "Quiénes somos",
      title: "Consultoría para decisiones que importan",
      p1: "CONSULTORA SER acompaña a organizaciones y equipos que trabajan frente a desafíos sociales, económicos, territoriales e institucionales complejos.",
      p2: "Combinamos investigación, análisis, participación y pensamiento estratégico para producir conocimiento útil y contribuir a mejores decisiones.",
      p3: "Nuestro trabajo parte de una premisa sencilla: una consultoría genera valor cuando sus resultados pueden ser comprendidos, utilizados y transformados en acción.",
      link: "Conozca más sobre nosotros",
      imageAlt: "Equipo de trabajo analizando documentos en un proceso participativo",
    },
    servicesSection: {
      overline: "Servicios",
      title: "Servicios especializados",
      intro: "Seis áreas de trabajo que conectan evidencia, análisis y estrategia.",
      learnMore: "Conocer más",
      viewAll: "Ver todos los servicios",
    },
    services: [
      {
        id: "planificacion-estrategica",
        icon: "compass",
        name: "Planificación Estratégica y Fortalecimiento Institucional",
        short: "Acompañamos procesos de reflexión, planificación y fortalecimiento que permiten a las organizaciones definir prioridades, ordenar su acción y orientar sus recursos hacia resultados.",
        intro: "Las organizaciones que trabajan en desarrollo enfrentan entornos cambiantes. Acompañamos procesos de planificación que ordenan prioridades, alinean equipos y orientan los recursos hacia resultados claros y medibles.",
        capabilities: ["Planificación estratégica", "Planificación operativa", "Teorías de cambio", "Marcos de resultados", "Estrategias institucionales", "Análisis organizacional", "Gestión de riesgos", "Fortalecimiento institucional"],
      },
      {
        id: "diseno-proyectos-resultados",
        icon: "pen",
        name: "Diseño de Proyectos y Marcos de Resultados",
        short: "Apoyamos la formulación de iniciativas coherentes, medibles y vinculadas con cambios claramente definidos.",
        intro: "Apoyamos la formulación de iniciativas coherentes y medibles, con teorías de cambio y marcos de resultados que vinculen acciones con los cambios que se buscan.",
        capabilities: ["Formulación de proyectos", "Teorías de cambio", "Marcos lógicos", "Cadenas de resultados", "Indicadores", "Supuestos", "Riesgos", "Sistemas de seguimiento"],
      },
      {
        id: "monitoreo-evaluacion-aprendizaje",
        icon: "clipboard",
        name: "Planificación, Monitoreo, Evaluación y Aprendizaje",
        short: "Diseñamos y desarrollamos procesos que permiten comprender avances, resultados, cambios, aprendizajes y oportunidades de mejora.",
        intro: "La evaluación es una herramienta de aprendizaje y mejora. Diseñamos y desarrollamos procesos de monitoreo, evaluación y aprendizaje (MEL) que permiten comprender qué está ocurriendo, qué está cambiando y cómo mejorar.",
        capabilities: ["Líneas de base", "Evaluaciones intermedias", "Evaluaciones finales", "Evaluación de resultados", "Marcos de indicadores", "Matrices de evaluación", "Sistemas de monitoreo", "Aprendizaje institucional"],
      },
      {
        id: "investigacion-estudios",
        icon: "search",
        name: "Investigación y Estudios",
        short: "Generamos evidencia para comprender contextos, poblaciones, instituciones, políticas, sectores y procesos sociales.",
        intro: "Realizamos investigación aplicada y estudios que generan evidencia rigurosa sobre contextos, poblaciones, instituciones, políticas y procesos sociales.",
        capabilities: ["Investigación aplicada", "Estudios diagnósticos", "Análisis de contexto", "Estudios sectoriales", "Mapeos", "Revisión documental", "Encuestas", "Entrevistas", "Grupos focales", "Métodos cualitativos y cuantitativos"],
      },
      {
        id: "analisis-datos-evidencia",
        icon: "chart",
        name: "Análisis de Datos y Evidencia",
        short: "Transformamos información cuantitativa y cualitativa en hallazgos comprensibles y útiles para la toma de decisiones.",
        intro: "SER no se limita a producir datos: ayudamos a las organizaciones a comprender qué significa la evidencia y qué decisiones permite tomar.",
        note: "No se trata únicamente de generar información. Se trata de comprender qué significa y qué decisiones permite tomar.",
        capabilities: ["Análisis cuantitativo", "Análisis cualitativo", "Revisión y depuración de bases", "Construcción de indicadores", "Visualización de datos", "Triangulación", "Síntesis de evidencia", "Interpretación de resultados"],
      },
      {
        id: "facilitacion-sistematizacion",
        icon: "users",
        name: "Facilitación, Sistematización y Aprendizaje",
        short: "Diseñamos procesos participativos que ayudan a reconstruir experiencias, generar aprendizajes colectivos y convertirlos en conocimiento útil.",
        intro: "Diseñamos y facilitamos procesos participativos que generan aprendizajes colectivos y los convierten en conocimiento útil para decidir y mejorar.",
        capabilities: ["Sistematización de experiencias", "Talleres estratégicos", "Facilitación", "Procesos participativos", "Aprendizaje institucional", "Guías metodológicas", "Productos de conocimiento"],
      },
    ],
    orgs: {
      overline: "Experiencia",
      title: "Organizaciones con las que colaboramos",
      text: "A lo largo de nuestra trayectoria hemos tenido la oportunidad de trabajar con las siguientes organizaciones.",
      link: "Conozca nuestra experiencia",
      logoAltPrefix: "Logotipo de",
    },
    howWeWork: {
      overline: "Metodología",
      title: "Cómo trabajamos",
      stages: [
        { num: "01", title: "Comprender", desc: "Partimos del contexto, las necesidades, las preguntas y las decisiones que la organización necesita tomar." },
        { num: "02", title: "Diseñar", desc: "Construimos metodologías ajustadas a cada proceso y a la evidencia necesaria." },
        { num: "03", title: "Escuchar e investigar", desc: "Integramos fuentes, datos y perspectivas utilizando métodos pertinentes para cada estudio." },
        { num: "04", title: "Analizar", desc: "Contrastamos evidencia, identificamos patrones y construimos hallazgos comprensibles." },
        { num: "05", title: "Convertir evidencia en acción", desc: "Traducimos el análisis en recomendaciones, estrategias, aprendizajes y herramientas útiles." },
      ],
      closing: "No se trata únicamente de generar información. Se trata de comprender qué significa y qué decisiones permite tomar.",
      imageAlt: "Personas analizando datos e impresiones durante un proceso de investigación",
    },
    principles: {
      title: "Principios que orientan nuestro trabajo",
      items: ["Rigor metodológico", "Independencia", "Ética", "Participación", "Confidencialidad", "Comprensión del contexto", "Análisis basado en evidencia", "Utilidad práctica"],
    },
    areas: {
      overline: "Ámbitos de trabajo",
      title: "Ámbitos en los que trabajamos",
      items: ["Desarrollo y cooperación internacional", "Derechos de las mujeres", "Igualdad de género", "Juventudes", "Educación", "Desarrollo territorial", "Desarrollo económico local", "Economía social y solidaria", "Fortalecimiento organizativo", "Participación ciudadana", "Acción humanitaria", "Gestión del riesgo de desastres", "Resiliencia comunitaria", "Seguridad alimentaria", "Cambio climático", "Agroecología", "Sostenibilidad", "Pueblos indígenas"],
    },
    questions: {
      title: "Comprender antes de recomendar.",
      items: ["¿Qué está ocurriendo?", "¿Por qué está ocurriendo?", "¿Qué nos dice la evidencia?", "¿Qué decisiones podemos tomar?"],
      closing: "Conectamos evidencia, análisis y estrategia.",
    },
    regional: "Experiencia construida desde Centroamérica, con una mirada regional.",
    finalCta: {
      title: "Cada proceso comienza con una pregunta",
      text: "",
      button: "Conversemos",
    },
    aboutPage: {
      overline: "Quiénes somos",
      title: "Consultoría para decisiones que importan",
      approach: {
        title: "Nuestro enfoque",
        p1: "Trabajamos en la intersección de cuatro ideas: personas, evidencia, estrategia y transformación. Comprendemos las realidades sociales desde dentro, con rigor metodológico y con las personas como protagonistas de los procesos.",
        p2: "Nuestro trabajo parte de una premisa sencilla: una consultoría genera valor cuando sus resultados pueden ser comprendidos, utilizados y transformados en acción.",
      },
      geo: {
        title: "Experiencia geográfica",
        text: "Experiencia construida desde Centroamérica, con una mirada regional. Hemos acompañado procesos con organizaciones e instituciones en El Salvador, Honduras y Guatemala.",
      },
    },
    values: {
      mission: {
        title: "Misión",
        p1: "Acompañar a organizaciones sociales, comunitarias y de cooperación en procesos de planificación, evaluación, investigación, análisis y fortalecimiento institucional, generando evidencia y herramientas prácticas que favorezcan mejores decisiones, aprendizajes y resultados sostenibles.",
        p2: "Nuestro trabajo se sustenta en el compromiso con los derechos humanos, la dignidad de las personas y la equidad. Mediante procesos participativos, combinamos escucha, análisis y comprensión del contexto para aportar, desde nuestro rol profesional, a cambios positivos en las organizaciones, las comunidades y sus territorios.",
      },
      vision: {
        title: "Visión",
        p1: "Ser una consultora reconocida por la utilidad de su trabajo y por su capacidad de acompañar a organizaciones comprometidas con la transformación positiva de las realidades en las que actúan.",
        p2: "Aspiramos a consolidar una práctica de consultoría con perspectiva regional e internacional, basada en la experiencia construida en Centroamérica, y la apertura a nuevas oportunidades de colaboración en distintos países y territorios, fortaleciendo vínculos de conocimiento, aprendizaje y cooperación.",
      },
      way: {
        title: "Nuestra manera de entender la consultoría",
        p1: "En Consultora SER investigamos, evaluamos y analizamos realidades que afectan la vida de las personas; por ello, nos importa comprender lo que ocurre y cómo nuestro trabajo puede contribuir a mejorar esas realidades.",
        p2: "Nuestro compromiso es generar conocimiento riguroso, independiente y útil que fortalezca a las organizaciones y contribuya a decisiones orientadas a ampliar derechos, reducir desigualdades y mejorar las condiciones de vida.",
      },
      principles: {
        title: "Nuestros principios",
        items: [
          {
            title: "Solidaridad",
            p: [
              "Entendemos nuestro trabajo como una relación de colaboración. Nos acercamos a cada proceso con empatía, responsabilidad y compromiso, reconociendo que detrás de los problemas que analizamos existen personas, comunidades y territorios.",
              "La solidaridad nos impulsa a poner nuestras capacidades profesionales al servicio de respuestas que contribuyan al bienestar colectivo.",
            ],
          },
          {
            title: "Equidad",
            p: [
              "Reconocemos que las personas y comunidades viven realidades y enfrentan oportunidades diferentes, y que la pobreza y las desigualdades tienen múltiples dimensiones.",
              "Por ello, promovemos procesos que incorporen distintas voces y perspectivas, especialmente las de quienes enfrentan mayores desigualdades o barreras para el ejercicio de sus derechos.",
              "La equidad orienta nuestra forma de investigar, analizar y acompañar la toma de decisiones.",
            ],
          },
          {
            title: "Respeto",
            p: [
              "Valoramos la identidad, los conocimientos, las experiencias y la autonomía de cada persona, organización y comunidad con la que trabajamos.",
              "Actuamos con ética, confidencialidad, transparencia e independencia profesional, procurando comprender cada contexto y cuidar las relaciones que construimos durante nuestros procesos.",
            ],
          },
        ],
        closing: "Solidaridad · Equidad · Respeto",
        closingText: "Estos tres principios dan sentido a nuestro nombre y orientan nuestra manera de trabajar.",
      },
    },
    howWeWorkPage: {
      overline: "Metodología",
      title: "Cómo trabajamos",
      intro: "Cada proceso es distinto, pero nuestra forma de trabajar sigue una lógica constante: comprender, diseñar, escuchar, analizar y convertir la evidencia en acción.",
    },
    teamPage: {
      overline: "Equipo",
      title: "Equipo Multidisciplinario",
      intro: "Somos un equipo multidisciplinario, comprometido con el cambio social y con una amplia diversidad de experiencias y conocimientos. Conocemos los territorios y sus realidades, y unimos distintas perspectivas para impulsar soluciones que generen oportunidades y transformaciones positivas.",
      specialtiesTitle: "Áreas de especialización",
      languagesLabel: "Idiomas",
      contactDirect: "Contactar a {name} directamente",
      callDirect: "Llamar a {name}",
      callIn: "Llamar a {name} en {place}",
      whatsappDirect: "Escribir a {name} por WhatsApp",
      hireVia: "Contratar a {name} a través de SER Consulting",
      backToTeam: "Volver al equipo",
    },
    diasporaPage: {
      overline: "Servicios para Salvadoreños",
      title: "Servicios en El Salvador y para salvadoreños en Estados Unidos",
      viewAll: "Ver todos los servicios",
      backTo: "Volver a Servicios para Salvadoreños",
      imageAlt: "Mapa que conecta Estados Unidos y El Salvador",
      sections: [
        {
          id: "servicios-el-salvador",
          kicker: "Servicios para Salvadoreños",
          title: "Servicios en El Salvador",
          summary: "Gestiones administrativas, legales, notariales, registrales, familiares y patrimoniales en El Salvador, coordinadas y acompañadas desde Estados Unidos.",
          lead: "Resuelve en El Salvador, estés donde estés.",
          paragraphs: [
            "Si vives en Estados Unidos y necesitas realizar una gestión administrativa, legal, notarial, registral, familiar o patrimonial en El Salvador, SER te acompaña y coordina la atención profesional en el país, facilitando la gestión desde Estados Unidos.",
            "Los servicios jurídicos son coordinados por Clara Alvarado, abogada salvadoreña e integrante de la Red de Especialistas SER, quien brinda orientación y seguimiento de acuerdo con las características de cada caso.",
          ],
          listTitle: "¿Qué podemos hacer por ti?",
          items: [
            "Gestiones relacionadas con bienes y propiedades en El Salvador.",
            "Gestiones administrativas y apoyo con documentación en El Salvador.",
            "Escrituras públicas y documentos notariales.",
            "Elaboración y revisión de contratos.",
            "Herencias y trámites sucesorios.",
            "Remedición de inmuebles.",
            "Títulos supletorios.",
            "Asesoría y trámites registrales.",
            "Rectificación de partidas de nacimiento.",
            "Legalización de documentos.",
            "Auténticas y certificaciones.",
            "Diligencias de traducción.",
            "Diligencias subsidiarias.",
            "Divorcios.",
            "Cuotas alimenticias.",
            "Régimen de visitas.",
            "Orientación jurídica para iniciar o formalizar empresas y negocios.",
            "Otras gestiones legales, notariales, familiares o patrimoniales.",
          ],
          subBlock: {
            title: "Desde Estados Unidos, con atención en El Salvador",
            text: "Sabemos que resolver un asunto en otro país puede implicar llamadas, documentos, coordinación y seguimiento. Nuestro propósito es facilitar el proceso y ayudarte a identificar los pasos necesarios para cada gestión.",
            phrase: "Tú nos explicas qué necesitas resolver y te orientamos sobre cómo proceder.",
          },
          helpBlock: {
            title: "Estamos para ayudarte",
            text: "Cuéntanos qué necesitas resolver. Revisaremos tu situación y te orientaremos sobre los pasos a seguir, procurando que el proceso sea claro, práctico y acompañado.",
          },
          values: {
            title: "Nuestra forma de acompañarte",
            intro: "En SER trabajamos desde tres principios que orientan nuestra relación con cada persona:",
            items: [
              { name: "Solidaridad", desc: "Buscamos comprender tu necesidad y acompañarte de manera cercana, práctica y humana." },
              { name: "Equidad", desc: "Reconocemos que cada persona y cada situación son diferentes, por eso buscamos alternativas adecuadas a tus circunstancias." },
              { name: "Respeto", desc: "Cuidamos tu tiempo, tu información, tus decisiones y la forma en que deseas resolver cada gestión." },
            ],
            closing: "Queremos que encuentres en SER un punto de apoyo confiable entre Estados Unidos y El Salvador.",
          },
          cta: "Cuéntanos qué necesitas",
        },
        {
          id: "servicios-estados-unidos",
          kicker: "Servicios para Salvadoreños",
          title: "Servicios en Estados Unidos",
          summary: "Apoyo práctico para resolver gestiones cotidianas, procesos digitales y coordinación de asuntos en El Salvador, además de organización, presencia digital y herramientas tecnológicas para iniciar, ordenar y hacer crecer tu negocio en Estados Unidos.",
          lead: "Estamos cerca para ayudarte a resolver, organizar y avanzar.",
          paragraphs: [
            "Vivir en Estados Unidos puede significar tener que resolver asuntos en dos países al mismo tiempo. En SER ofrecemos acompañamiento cercano y práctico para personas salvadoreñas que necesitan apoyo con gestiones cotidianas, herramientas digitales, coordinación de asuntos en El Salvador o el desarrollo de sus propios negocios.",
            "Nuestro objetivo es sencillo: hacer más fáciles aquellas gestiones que pueden complicarse por la distancia, el tiempo o la tecnología.",
            "Hay gestiones que pueden resultar complicadas por la distancia, el tiempo o el uso de herramientas digitales. En SER ofrecemos acompañamiento práctico para ayudarte a resolverlas.",
            "Si estás comenzando un negocio o ya tienes uno funcionando, también podemos ayudarte a organizarlo, fortalecer su presencia y aprovechar mejor las herramientas digitales.",
          ],
          listTitle: "Podemos apoyarte con:",
          items: [
            "Coordinación de envío de documentos y encomiendas entre Estados Unidos y El Salvador.",
            "Orientación en gestiones administrativas.",
            "Gestiones digitales y uso de herramientas tecnológicas.",
            "Apoyo para completar procesos y formularios en línea.",
            "Organización y envío de documentación digital.",
            "Coordinación y seguimiento de diligencias en El Salvador.",
            "Apoyo para resolver asuntos personales a distancia.",
            "Comunicación y coordinación con personas o instituciones en El Salvador.",
            "Orientación para identificar dónde y cómo realizar una determinada gestión.",
          ],
          note: "Este servicio está pensado para quienes necesitan apoyo adicional con procesos digitales, administrativos o gestiones a distancia.",
          list2Title: "¿Qué podemos hacer por tu negocio?",
          items2: [
            "Orientación para organizar una idea de negocio.",
            "Apoyo en procesos administrativos.",
            "Organización de servicios, precios y procesos.",
            "Diseño de procesos de atención al cliente.",
            "Desarrollo y gestión de sitios web.",
            "Seguridad y mantenimiento web.",
            "Google Business Profile.",
            "Formularios de contacto y cotización.",
            "Sistemas de reservación y calendarios.",
            "Automatización de procesos.",
            "Implementación de CRM.",
            "Organización y seguimiento de clientes.",
            "Marketing digital.",
            "SEO y posicionamiento en buscadores.",
            "Fortalecimiento de la presencia digital.",
            "Integración de sitio web, formularios, calendario, CRM y otras herramientas.",
          ],
          noteBlock: {
            title: "No tienes que saber de tecnología",
            text: "Nos explicas qué necesitas hacer o qué quieres lograr. Nosotros te ayudamos a identificar una alternativa práctica y te acompañamos durante el proceso.",
            closing: "Ya sea que necesites resolver una gestión cotidiana, coordinar algo en El Salvador o hacer crecer tu negocio en Estados Unidos, buscamos que tengas un punto de apoyo cercano y confiable.",
          },
          values: {
            title: "Nuestra forma de acompañarte",
            intro: "En SER trabajamos desde tres principios que orientan nuestra relación con cada persona:",
            items: [
              { name: "Solidaridad", desc: "Escuchamos tu necesidad y buscamos acompañarte de manera cercana y humana." },
              { name: "Equidad", desc: "Entendemos que cada persona tiene circunstancias distintas y buscamos soluciones que respondan a su realidad." },
              { name: "Respeto", desc: "Cuidamos tu tiempo, tu información, tus decisiones y la manera en que deseas avanzar." },
            ],
            closing: "Nuestro propósito es que tengas un punto de apoyo cercano y confiable para resolver, organizar y avanzar entre Estados Unidos y El Salvador.",
          },
          cta: "Cuéntanos qué necesitas",
        },
      ],
    },
    servicesPage: {
      overline: "Servicios",
      title: "Servicios especializados",
      intro: "Seis áreas de trabajo que conectan evidencia, análisis y estrategia para apoyar mejores decisiones en organizaciones de desarrollo y cooperación.",
      capabilitiesTitle: "Capacidades",
    },
    contactPage: {
      overline: "Contacto",
      title: "Conversemos sobre nuestra próxima cooperación",
      text: "Si su organización está planificando una evaluación, investigación, proceso estratégico o requiere apoyo especializado, estaremos encantados de conocer sus necesidades.",
      form: {
        firstName: "Nombre",
        lastName: "Apellido",
        organization: "Organización",
        email: "Correo electrónico",
        country: "País",
        service: "¿En qué podemos apoyarle?",
        message: "Cuéntenos brevemente sobre su necesidad",
        submit: "Enviar consulta",
        sending: "Enviando…",
        selectPlaceholder: "Seleccione una opción",
        options: ["Evaluación", "Investigación", "Planificación Estratégica", "Análisis de Datos", "Diseño de Proyectos", "Facilitación y Sistematización", "Otro"],
        success: "Gracias. Hemos recibido su consulta y le responderemos a la brevedad.",
        error: "No se pudo enviar la consulta. Inténtelo de nuevo, por favor.",
        required: "Campo obligatorio",
      },
    },
    privacyPage: {
      title: "Política de privacidad",
      text: "Contenido en preparación. La información enviada a través del formulario de contacto se utiliza únicamente para responder a su consulta.",
    },
    footer: {
      tagline: "Construimos cambios sostenibles a través de redes de cooperación, alianzas, diálogo y acción conjunta.",
      navTitle: "Navegación",
      servicesTitle: "Servicios",
      contactTitle: "Contacto",
      emailSoon: "Correo oficial disponible próximamente",
      privacy: "Política de privacidad",
      rights: "© CONSULTORA SER. Todos los derechos reservados.",
      dba: "SER CONSULTING es un DBA de SER ADVISORY AND SERVICES CORPORATION. California, Estados Unidos de América.",
    },
    seo: {
      home: { title: "Consultora SER | Evaluación, Investigación y Planificación Estratégica", desc: "Consultoría especializada en evaluación, investigación, planificación estratégica, análisis de datos y fortalecimiento institucional para organizaciones de desarrollo y cooperación." },
      about: { title: "Quiénes somos | Consultora SER", desc: "Consultoría especializada que combina investigación, análisis, participación y pensamiento estratégico para contribuir a mejores decisiones." },
      team: { title: "Equipo Multidisciplinario | Consultora SER", desc: "Conozca al equipo multidisciplinario de Consultora SER: profesionales de varios países en evaluación, investigación, planificación estratégica y fortalecimiento institucional." },
      services: { title: "Servicios | Consultora SER", desc: "Planificación estratégica, monitoreo, evaluación y aprendizaje, investigación, análisis de datos, diseño de proyectos y facilitación." },
      contact: { title: "Contacto | Consultora SER", desc: "Conversemos sobre su próximo proyecto de evaluación, investigación o planificación estratégica." },
      diaspora: { title: "Servicios para Salvadoreños | Consultora SER", desc: "Servicios en El Salvador y acompañamiento para salvadoreños en Estados Unidos: gestiones legales, notariales y administrativas, apoyo personal y soluciones para negocios." },
    },
    notFound: { title: "Página no encontrada", link: "Volver al inicio" },
  },
  en: {
    brandName: "SER CONSULTING",
    skipToContent: "Skip to main content",
    nav: {
      home: "Home",
      about: "About Us",
      team: "Team",
      services: "Services",
      diaspora: "Services for Salvadorans",
      contact: "Contact",
    },
    cta: "Let’s Talk",
    brandTagline: "Solidarity - Equity - Respect",
    hero: {
      overline: "Consulting · Development · Cooperation",
      line1: "We build sustainable change",
      line2: "through cooperation networks, partnerships, dialogue and joint action.",
      sub: "The network of professionals at SER Consulting accompanies organizations through education, training, research, strategic planning, evaluation, results-oriented management and organizational strengthening.",
      primary: "Let’s Talk",
      secondary: "Explore our experience",
    },
    marquee: ["Education", "Training", "Research", "Evaluation", "Planning", "Data", "Learning", "Institutional Strengthening"],
    whoWeAre: {
      overline: "About us",
      title: "Consulting for decisions that matter",
      p1: "SER Consulting supports organizations and teams addressing complex social, economic, territorial and institutional challenges.",
      p2: "We combine research, analysis, participation and strategic thinking to produce useful knowledge and support better decisions.",
      p3: "Our work begins with a simple premise: consulting creates value when its findings can be understood, used and transformed into action.",
      link: "Learn more about us",
      imageAlt: "Team analyzing documents during a participatory process",
    },
    servicesSection: {
      overline: "Services",
      title: "Specialized services",
      intro: "Six areas of work connecting evidence, analysis and strategy.",
      learnMore: "Learn more",
      viewAll: "View all services",
    },
    services: [
      {
        id: "planificacion-estrategica",
        icon: "compass",
        name: "Strategic Planning & Institutional Strengthening",
        short: "We support reflection, planning and strengthening processes that help organizations define priorities, organize their work and direct resources toward results.",
        intro: "Organizations working in development face changing environments. We support planning processes that set priorities, align teams and direct resources toward clear, measurable results.",
        capabilities: ["Strategic planning", "Operational planning", "Theories of change", "Results frameworks", "Institutional strategies", "Organizational analysis", "Risk management", "Institutional strengthening"],
      },
      {
        id: "diseno-proyectos-resultados",
        icon: "pen",
        name: "Project Design & Results Frameworks",
        short: "We support the design of coherent, measurable initiatives linked to clearly defined change.",
        intro: "We support the formulation of coherent, measurable initiatives, with theories of change and results frameworks that link actions to the change they seek.",
        capabilities: ["Project formulation", "Theories of change", "Logical frameworks", "Results chains", "Indicators", "Assumptions", "Risks", "Monitoring systems"],
      },
      {
        id: "monitoreo-evaluacion-aprendizaje",
        icon: "clipboard",
        name: "Planning, Monitoring, Evaluation & Learning",
        short: "We design and deliver processes that make it possible to understand progress, results, change, learning and opportunities for improvement.",
        intro: "Evaluation is a tool for learning and improvement. We design and deliver monitoring, evaluation and learning (MEL) processes that reveal what is happening, what is changing and how to improve.",
        capabilities: ["Baseline studies", "Midterm evaluations", "Final evaluations", "Outcome evaluations", "Indicator frameworks", "Evaluation matrices", "Monitoring systems", "Institutional learning"],
      },
      {
        id: "investigacion-estudios",
        icon: "search",
        name: "Research & Studies",
        short: "We generate evidence to understand contexts, populations, institutions, policies, sectors and social processes.",
        intro: "We carry out applied research and studies that generate rigorous evidence on contexts, populations, institutions, policies and social processes.",
        capabilities: ["Applied research", "Diagnostic studies", "Context analysis", "Sector studies", "Mappings", "Document review", "Surveys", "Interviews", "Focus groups", "Qualitative and quantitative methods"],
      },
      {
        id: "analisis-datos-evidencia",
        icon: "chart",
        name: "Data & Evidence Analysis",
        short: "We turn quantitative and qualitative information into clear, useful findings for decision-making.",
        intro: "SER does not simply produce data. We help organizations understand what the evidence means and which decisions it makes possible.",
        note: "It is not only about producing information. It is about understanding what it means and what decisions it enables.",
        capabilities: ["Quantitative analysis", "Qualitative analysis", "Database review and cleaning", "Indicator construction", "Data visualization", "Triangulation", "Evidence synthesis", "Results interpretation"],
      },
      {
        id: "facilitacion-sistematizacion",
        icon: "users",
        name: "Facilitation, Systematization & Learning",
        short: "We design participatory processes that help reconstruct experiences, generate collective learning and turn it into useful knowledge.",
        intro: "We design and facilitate participatory processes that generate collective learning and turn it into knowledge that is useful for deciding and improving.",
        capabilities: ["Experience systematization", "Strategic workshops", "Facilitation", "Participatory processes", "Institutional learning", "Methodological guides", "Knowledge products"],
      },
    ],
    orgs: {
      overline: "Experience",
      title: "Organizations we collaborate with",
      text: "Throughout our professional experience, we have had the opportunity to work with the following organizations.",
      link: "Explore our experience",
      logoAltPrefix: "Logo of",
    },
    howWeWork: {
      overline: "Methodology",
      title: "How we work",
      stages: [
        { num: "01", title: "Understand", desc: "We start from the context, the needs, the questions and the decisions the organization needs to make." },
        { num: "02", title: "Design", desc: "We build methodologies tailored to each process and to the evidence required." },
        { num: "03", title: "Listen & Research", desc: "We bring together sources, data and perspectives, using methods suited to each study." },
        { num: "04", title: "Analyze", desc: "We cross-check evidence, identify patterns and build findings that can be understood." },
        { num: "05", title: "Turn Evidence into Action", desc: "We translate analysis into recommendations, strategies, learning and useful tools." },
      ],
      closing: "It is not only about producing information. It is about understanding what it means and what decisions it enables.",
      imageAlt: "People analyzing data and printouts during a research process",
    },
    principles: {
      title: "Principles that guide our work",
      items: ["Methodological rigor", "Independence", "Ethics", "Participation", "Confidentiality", "Context awareness", "Evidence-based analysis", "Practical usefulness"],
    },
    areas: {
      overline: "Areas of work",
      title: "Areas we work in",
      items: ["International development & cooperation", "Women’s rights", "Gender equality", "Youth", "Education", "Territorial development", "Local economic development", "Social & solidarity economy", "Organizational strengthening", "Citizen participation", "Humanitarian action", "Disaster risk management", "Community resilience", "Food security", "Climate change", "Agroecology", "Sustainability", "Indigenous peoples"],
    },
    questions: {
      title: "Understand before recommending.",
      items: ["What is happening?", "Why is it happening?", "What does the evidence tell us?", "What decisions can we make?"],
      closing: "We connect evidence, analysis and strategy.",
    },
    regional: "Experience rooted in Central America, with a regional perspective.",
    finalCta: {
      title: "Every process begins with a question",
      text: "",
      button: "Let’s Talk",
    },
    aboutPage: {
      overline: "About us",
      title: "Consulting for decisions that matter",
      approach: {
        title: "Our approach",
        p1: "We work at the intersection of four ideas: people, evidence, strategy and transformation. We understand social realities from within, with methodological rigor and with people as protagonists of every process.",
        p2: "Our work begins with a simple premise: consulting creates value when its findings can be understood, used and transformed into action.",
      },
      geo: {
        title: "Geographic experience",
        text: "Experience rooted in Central America, with a regional perspective. We have supported processes with organizations and institutions in El Salvador, Honduras and Guatemala.",
      },
    },
    values: {
      mission: {
        title: "Mission",
        p1: "To accompany social, community and cooperation organizations through planning, evaluation, research, analysis and institutional strengthening processes, generating evidence and practical tools that support better decisions, learning and sustainable results.",
        p2: "Our work is grounded in a commitment to human rights, human dignity and equity. Through participatory processes, we combine listening, analysis and contextual understanding to contribute, from our professional role, to positive change in organizations, communities and their territories.",
      },
      vision: {
        title: "Vision",
        p1: "To be a consulting firm recognized for the usefulness of its work and for its ability to accompany organizations committed to the positive transformation of the realities in which they work.",
        p2: "We aspire to consolidate a consulting practice with a regional and international perspective, built on the experience developed in Central America and open to new opportunities for collaboration across countries and territories, strengthening bonds of knowledge, learning and cooperation.",
      },
      way: {
        title: "Our way of understanding consulting",
        p1: "At SER Consulting we research, evaluate and analyze realities that affect people's lives; that is why we care about understanding what is happening and how our work can help improve those realities.",
        p2: "Our commitment is to generate rigorous, independent and useful knowledge that strengthens organizations and contributes to decisions aimed at expanding rights, reducing inequalities and improving living conditions.",
      },
      principles: {
        title: "Our principles",
        items: [
          {
            title: "Solidarity",
            p: [
              "We understand our work as a collaborative relationship. We approach every process with empathy, responsibility and commitment, recognizing that behind the problems we analyze there are people, communities and territories.",
              "Solidarity drives us to put our professional capabilities at the service of responses that contribute to collective wellbeing.",
            ],
          },
          {
            title: "Equity",
            p: [
              "We recognize that people and communities live different realities and face different opportunities, and that poverty and inequality have multiple dimensions.",
              "That is why we promote processes that incorporate diverse voices and perspectives, especially those of people facing the greatest inequalities or barriers to exercising their rights.",
              "Equity guides the way we research, analyze and support decision-making.",
            ],
          },
          {
            title: "Respect",
            p: [
              "We value the identity, knowledge, experience and autonomy of every person, organization and community we work with.",
              "We act with ethics, confidentiality, transparency and professional independence, seeking to understand each context and to care for the relationships we build throughout our processes.",
            ],
          },
        ],
        closing: "Solidarity · Equity · Respect",
        closingText: "These three principles give meaning to our name and guide the way we work.",
      },
    },
    howWeWorkPage: {
      overline: "Methodology",
      title: "How we work",
      intro: "Every process is different, but the way we work follows a constant logic: understand, design, listen, analyze and turn evidence into action.",
    },
    teamPage: {
      overline: "Team",
      title: "Multidisciplinary Team",
      intro: "We are a multidisciplinary team, committed to social change and with a wide diversity of experiences and knowledge. We know the territories and their realities, and we bring together different perspectives to drive solutions that create opportunities and positive transformations.",
      specialtiesTitle: "Areas of expertise",
      languagesLabel: "Languages",
      contactDirect: "Contact {name} directly",
      callDirect: "Call {name}",
      callIn: "Call {name} in {place}",
      whatsappDirect: "Message {name} on WhatsApp",
      hireVia: "Hire {name} through SER Consulting",
      backToTeam: "Back to the team",
    },
    diasporaPage: {
      overline: "Services for Salvadorans",
      title: "Services in El Salvador and for Salvadorans in the United States",
      viewAll: "View all services",
      backTo: "Back to Services for Salvadorans",
      imageAlt: "Map connecting the United States and El Salvador",
      sections: [
        {
          id: "servicios-el-salvador",
          kicker: "Services for Salvadorans",
          title: "Services in El Salvador",
          summary: "Administrative, legal, notarial, registry, family and property-related procedures in El Salvador, coordinated and accompanied from the United States.",
          lead: "Resolve matters in El Salvador, wherever you are.",
          paragraphs: [
            "If you live in the United States and need to carry out an administrative, legal, notarial, registry, family or property-related procedure in El Salvador, SER accompanies you and coordinates professional attention in the country, facilitating the process from the United States.",
            "Legal services are coordinated by Clara Alvarado, a Salvadoran attorney and member of the SER Expert Network, who provides guidance and follow-up according to the characteristics of each case.",
          ],
          listTitle: "What can we do for you?",
          items: [
            "Procedures related to goods and properties in El Salvador.",
            "Administrative procedures and support with documentation in El Salvador.",
            "Public deeds and notarial documents.",
            "Drafting and review of contracts.",
            "Inheritances and probate proceedings.",
            "Property re-measurement.",
            "Supplementary titles.",
            "Registry advisory and procedures.",
            "Correction of birth records.",
            "Legalization of documents.",
            "Authentications and certifications.",
            "Translation errands.",
            "Subsidiary proceedings.",
            "Divorces.",
            "Child support.",
            "Visitation arrangements.",
            "Legal guidance to start or formalize companies and businesses.",
            "Other legal, notarial, family or property-related procedures.",
          ],
          subBlock: {
            title: "From the United States, with attention in El Salvador",
            text: "We know that resolving a matter in another country can involve calls, documents, coordination and follow-up. Our purpose is to facilitate the process and help you identify the steps needed for each procedure.",
            phrase: "You tell us what you need to resolve, and we guide you on how to proceed.",
          },
          helpBlock: {
            title: "We are here to help you",
            text: "Tell us what you need to resolve. We will review your situation and guide you on the steps to follow, making sure the process is clear, practical and accompanied.",
          },
          values: {
            title: "Our way of accompanying you",
            intro: "At SER we work from three principles that guide our relationship with each person:",
            items: [
              { name: "Solidarity", desc: "We seek to understand your need and accompany you in a close, practical and humane way." },
              { name: "Equity", desc: "We recognize that every person and every situation is different, so we look for alternatives suited to your circumstances." },
              { name: "Respect", desc: "We take care of your time, your information, your decisions and the way you wish to resolve each matter." },
            ],
            closing: "We want you to find in SER a reliable point of support between the United States and El Salvador.",
          },
          cta: "Tell us what you need",
        },
        {
          id: "servicios-estados-unidos",
          kicker: "Services for Salvadorans",
          title: "Services in the United States",
          summary: "Practical support to resolve everyday procedures, digital processes and coordination of matters in El Salvador, plus organization, digital presence and technological tools to start, organize and grow your business in the United States.",
          lead: "We are close by to help you resolve, organize and move forward.",
          paragraphs: [
            "Living in the United States can mean having to resolve matters in two countries at the same time. At SER we offer close and practical support for Salvadoran people who need help with everyday procedures, digital tools, coordination of matters in El Salvador or the development of their own businesses.",
            "Our goal is simple: to make easier those procedures that can become complicated by distance, time or technology.",
            "Some procedures can become complicated because of distance, time or the use of digital tools. At SER we offer practical assistance to help you resolve them.",
            "If you are starting a business or already have one running, we can also help you organize it, strengthen its presence and make better use of digital tools.",
          ],
          listTitle: "We can support you with:",
          items: [
            "Coordination of document and parcel shipping between the United States and El Salvador.",
            "Guidance on administrative procedures.",
            "Digital procedures and use of technological tools.",
            "Support to complete online processes and forms.",
            "Organization and delivery of digital documentation.",
            "Coordination and follow-up of errands in El Salvador.",
            "Support to resolve personal matters remotely.",
            "Communication and coordination with people or institutions in El Salvador.",
            "Guidance to identify where and how to carry out a particular procedure.",
          ],
          note: "This service is designed for those who need additional support with digital processes, administrative procedures or remote errands.",
          list2Title: "What can we do for your business?",
          items2: [
            "Guidance to organize a business idea.",
            "Support with administrative processes.",
            "Organization of services, prices and processes.",
            "Design of customer service processes.",
            "Website development and management.",
            "Web security and maintenance.",
            "Google Business Profile.",
            "Contact and quotation forms.",
            "Booking systems and calendars.",
            "Process automation.",
            "CRM implementation.",
            "Customer organization and follow-up.",
            "Digital marketing.",
            "SEO and search engine positioning.",
            "Strengthening of digital presence.",
            "Integration of website, forms, calendar, CRM and other tools.",
          ],
          noteBlock: {
            title: "You don't need to know about technology",
            text: "You tell us what you need to do or what you want to achieve. We help you identify a practical alternative and accompany you throughout the process.",
            closing: "Whether you need to resolve an everyday errand, coordinate something in El Salvador or grow your business in the United States, we want you to have a close and reliable point of support.",
          },
          values: {
            title: "Our way of accompanying you",
            intro: "At SER we work from three principles that guide our relationship with each person:",
            items: [
              { name: "Solidarity", desc: "We listen to your need and seek to accompany you in a close and humane way." },
              { name: "Equity", desc: "We understand that every person has different circumstances and we look for solutions that respond to their reality." },
              { name: "Respect", desc: "We take care of your time, your information, your decisions and the way you wish to move forward." },
            ],
            closing: "Our purpose is for you to have a close and reliable point of support to resolve, organize and move forward between the United States and El Salvador.",
          },
          cta: "Tell us what you need",
        },
      ],
    },
    servicesPage: {
      overline: "Services",
      title: "Specialized services",
      intro: "Six areas of work connecting evidence, analysis and strategy to support better decisions in development and cooperation organizations.",
      capabilitiesTitle: "Capabilities",
    },
    contactPage: {
      overline: "Contact",
      title: "Let’s talk about our next collaboration",
      text: "If your organization is planning an evaluation, research study, strategic process or requires specialized support, we would be glad to learn more about your needs.",
      form: {
        firstName: "First Name",
        lastName: "Last Name",
        organization: "Organization",
        email: "Email",
        country: "Country",
        service: "How can we help?",
        message: "Tell us briefly about your needs",
        submit: "Send inquiry",
        sending: "Sending…",
        selectPlaceholder: "Select an option",
        options: ["Evaluation", "Research", "Strategic Planning", "Data Analysis", "Project Design", "Facilitation & Systematization", "Other"],
        success: "Thank you. We have received your inquiry and will get back to you shortly.",
        error: "Your inquiry could not be sent. Please try again.",
        required: "Required field",
      },
    },
    privacyPage: {
      title: "Privacy Policy",
      text: "Content in preparation. Information submitted through the contact form is used solely to respond to your inquiry.",
    },
    footer: {
      tagline: "We build sustainable change through cooperation networks, partnerships, dialogue and joint action.",
      navTitle: "Navigation",
      servicesTitle: "Services",
      contactTitle: "Contact",
      emailSoon: "Official email available soon",
      privacy: "Privacy Policy",
      rights: "© SER CONSULTING. All rights reserved.",
      dba: "SER CONSULTING is a DBA of SER ADVISORY AND SERVICES CORPORATION. California, United States of America.",
    },
    seo: {
      home: { title: "SER Consulting | Evaluation, Research & Strategic Planning", desc: "Specialized consulting in evaluation, research, strategic planning, data analysis and institutional strengthening for development and cooperation organizations." },
      about: { title: "About Us | SER Consulting", desc: "A specialized consulting firm combining research, analysis, participation and strategic thinking to support better decisions." },
      team: { title: "Multidisciplinary Team | SER Consulting", desc: "Meet the multidisciplinary team of SER Consulting: professionals from several countries in evaluation, research, strategic planning and institutional strengthening." },
      services: { title: "Services | SER Consulting", desc: "Strategic planning, monitoring, evaluation & learning, research, data analysis, project design and facilitation." },
      contact: { title: "Contact | SER Consulting", desc: "Let’s talk about your next evaluation, research or strategic planning project." },
      diaspora: { title: "Services for Salvadorans | SER Consulting", desc: "Services in El Salvador and support for Salvadorans in the United States: legal, notarial and administrative procedures, personal assistance and business solutions." },
    },
    notFound: { title: "Page not found", link: "Back to home" },
  },
};
